import React, { SVGProps } from 'react'

export const KnockNMLSIDIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="icon-nmls" {...props}>
    <title>NMLS icon</title>
    <g clipPath="url(#a)" fill="#232F3B">
      <path d="M1.419 14V7.082H.313c0-.654.021-1.277-.009-1.899-.015-.324.09-.485.384-.618.828-.375 1.638-.786 2.457-1.18.638-.308 1.28-.611 1.919-.917l2.08-1.001c.656-.315 1.31-.63 1.967-.941.367-.174.736-.342 1.109-.503.06-.027.155-.032.21-.004.614.32 1.225.646 1.834.973.706.38 1.412.761 2.117 1.143l3.162 1.715c.668.363 1.337.723 2 1.09.065.036.145.118.146.179.01.728.007 1.455.007 2.21h-1.264v6.67H1.419V14Zm14.871-2.085c.005-.067.01-.11.01-.152 0-1.99 0-3.978.004-5.967 0-.178-.088-.263-.225-.337-.894-.488-1.784-.981-2.68-1.465-.881-.476-1.776-.929-2.648-1.42-.329-.186-.605-.193-.934-.019-.454.24-.93.438-1.394.66-.834.402-1.666.809-2.5 1.211-.7.338-1.399.682-2.107 1.003-.262.118-.36.263-.357.565.018 1.867.009 3.734.009 5.601v.32H16.29Z" />
      <path d="M13.046 7.84H6.629V5.78h6.416V7.84ZM6.617 10.64V8.595h6.434v2.043H6.617Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" transform="translate(.303)" d="M0 0h19.395v14H0z" />
      </clipPath>
    </defs>
  </svg>
)
